import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent, actionNames, actionPrefixes } from "@newsela/snitch";
import getButtonProps from "../utils/getButtonProps";
import useEventProperties from "../utils/useEventProperties";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  annotationId: PropTypes.number,
  buttonFlavor: PropTypes.string,
  handleCancel: PropTypes.func,
};

const CancelButton = ({ annotationId, buttonFlavor, handleCancel }) => {
  const eventProperties = useEventProperties(
    annotationId,
    actionNames.update,
    "Cancel annotation edit",
    actionPrefixes.cancel,
  );
  return (
    <ButtonWithTrackEvent
      onClick={handleCancel}
      {...getButtonProps(buttonFlavor)}
      {...eventProperties}
    >
      Cancel
    </ButtonWithTrackEvent>
  );
};

CancelButton.propTypes = propTypes;

export default CancelButton;
